import {
  mapGetters,
} from 'vuex';

export default {
  name: 'SlotsPicker',
  components: {},
  props: {
    date: null,
    isActive: false,
    availableSlots: {
      type: Array,
      default: [],
    },
  },
  data: () => ({}),
  computed: {
    ...mapGetters('appointment', {
      errorSlot: 'getErrorSlot',
    }),
  },
  methods: {
    closeSlotsPicker() {
      this.$emit('on-close-slots-picker');
    },
    clickedOnSlot(availableSlot) {
      if (availableSlot.available) {
        this.$emit('on-close-slots-picker', availableSlot);
      }
    },
  },
};
